import { queryOptions } from "@tanstack/react-query";
import { STALE } from "@/lib/api/query-client";
import { keys } from "@/lib/api/query-keys";
import { approvalsApi } from "./approvals.api";

export function approvalInboxQuery(filters: {
  page?: number;
  limit?: number;
  sortBy?: "dueAt" | "createdAt" | "stepNo";
  sortOrder?: "asc" | "desc";
  subjectType?: string;
  overdue?: boolean;
}) {
  return queryOptions({
    queryKey: keys.workflow.approvals.inbox(filters),
    queryFn: () => approvalsApi.inbox(filters),
    // A work queue: somebody else's decision changes it while this screen is open.
    staleTime: STALE.live,
  });
}

/**
 * The approval history for one record.
 *
 * Its own query rather than a field on the record, because the two have different lifetimes:
 * the record is edited, the history only ever grows, and a screen showing both should not
 * refetch the history every time a field changes.
 */
export function approvalForSubjectQuery(entityType: string, entityId: string | null) {
  return queryOptions({
    queryKey: keys.workflow.approvals.detail(`${entityType}:${entityId ?? ""}`),
    queryFn: () =>
      approvalsApi.forSubject({
        entityType,
        entityId: entityId as string,
        includeClosed: true,
      }),
    enabled: entityId !== null && entityId !== "",
    staleTime: STALE.record,
  });
}
